module.exports = __webpack_public_path__ + "static/media/6.20ef637c.mp3";